import type { ObrasViewProps } from "./types-obras-view";
import { useObrasView } from "./use-obras-view";
import { ObrasViewView } from "./view-obras-view";

export function ObrasView(props: ObrasViewProps) {
  const vm = useObrasView(props);

  return <ObrasViewView {...vm} />;
}

export type * from "./types-obras-view";
